export default __webpack_public_path__ + "static/media/1.7a4406d3.png";